"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _ramda = require("ramda");

var normalizeArray = function normalizeArray(val, length) {
  return (0, _ramda.is)(Array, val) ? [].concat(val, (0, _ramda.repeat)((0, _ramda.last)(val), length - val.length)) : Array(length).fill(val);
};

var _default = normalizeArray;
exports["default"] = _default;